// Single decision point for the Directorio UI/UX rework: resolves the redesigned list
// view when the society has HAS_NEW_AP_VIEW, else the current one. Default is the OLD view
// (flag false when the permission is absent). Neither view reads the flag.
//
// Same shape as `resolveRequestsView` — see that file for why the resolver is the route
// record's `component` instead of a `<component :is>` dispatcher, and for the accepted
// tradeoff that toggling the permission needs a page reload to take effect.
import { checkFeatureFlag, FEATURES } from "@/features";

export function resolveProvidersView() {
  return checkFeatureFlag(FEATURES.NEW_AP_VIEW)
    ? import("@/views/providers/Providers.vue")
    : import("@/views/providers/ProvidersLegacy.vue");
}
